<template lang="html">
  <section :id="id" v-if="visible" v-on:click="onSelected">
    <div class="hardcoded-value">
      <mark v-if="hasNewToken && exp">&quot;{{ updatedLabel }}&quot;</mark>
      <mark v-else>&quot;{{ exp }}&quot;</mark>
    </div>
  </section>
</template>

<script lang="js">
  import { v4 as uuidv4 } from "uuid";
  import stringUtil from "@/utils/string-util";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import store from "@/store";

  export default  {
    name: "hardcoded-string",
    props: {
      id: {
        type: String,
        default: "static-string-" + uuidv4()
      },
      hasNewToken: {
        type: Boolean,
        value: false
      },
      isFromConcat: {
        type: Boolean,
        value: false
      },
      exp: {
        type: String
      }
    },
    watch: {
      exp: function() {
        this.updateDisplay();
      }
    },
    computed: {
      updatedLabel() {
        return this.$t("newLabelWithToken").replace('"{0}"', this.exp)
      }
    },
    mounted () {
      this.updateDisplay();
    },
    data () {
      return {
        visible: false
      }
    },
    methods: {
      onSelected() {
        if(this.$listeners && this.$listeners["on-search-box-item-selected"]) {
          this.$emit("on-search-box-item-selected", this.getExpression());
        }
      },
      updateDisplay() {
        this.visible = this.isValid() && ((this.hasNewToken && this.exp) || this.isFromConcat);
      },
      isValid() {
        return stringUtil.isValidString(this.exp, store.getters.userLocale);
      },
      getExpression() {
        return expressionBuilder.getStaticStringExpression({value: this.exp});
      }
    }
  }
</script>

<style scoped lang="scss">
  .hardcoded-value {
    overflow: hidden;
    padding: 0.75rem;
    white-space: pre;
  }
</style>
